import "./SearchBar.css";
import React, { useEffect, useState, useRef } from "react";
import { FaSearch } from "react-icons/fa";
import CustomSelect from "./CustomSelect";

function SearchBar({
    searchInput,
    activeFilters, 
    onSearchChange, 
    onFilterChange, 
    filters, 
    setFilters, 
    dropdown, 
    placeholder
}) {
    // Managing Search Input
    const inputRef = useRef(null);
// const [searchInput, setSearchInput] = useState("");

    // expand the navbar search bar when clicked
    const focusInput = () => {
        inputRef.current.focus();

        if (dropdown) {
            const searchBarDropdown = document.querySelector(
                ".search-bar-input"
            );
            searchBarDropdown.style.width = "400px";
        }

        const targetElement = document.getElementById("search-area");
        const offset = 40;
        const targetPosition = targetElement.offsetTop - offset;

        window.scrollTo({
            top: targetPosition,
            behavior: "smooth",
        });
    };

    return (
        <div className={"flex search-bar-input-row"}>
            <>
                <FaSearch size={19} onClick={focusInput} className="react-icon" />
                <input
                    ref={inputRef}
                    className={
                        "subtle-text search-bar-input" +
                        (dropdown ? "" : " home-page-search-input")
                    }
                    value={searchInput}
                    onChange={(e) => {
                        onSearchChange(e.target.value);
                    }}
                    onClick={focusInput}
                    placeholder={placeholder}
                ></input>
            </>
           
            <CustomSelect
                options={filters}
                handleChange={(event) => {
                    const newFilters = event.target.value.filter(item => item !== undefined);
                    onFilterChange(newFilters);
                }}
                value={activeFilters}
                setOptions={setFilters}
            />
        </div>
    );
}
export default SearchBar;
